const RewardsSvgIcon = ({ stroke }) => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5 21.4V16.4M3.5 6.40002V1.40002M1 3.90002H6M1 18.9H6M12 2.40002L10.2658 6.90889C9.98381 7.64212 9.84281 8.00873 9.62353 8.31711C9.42919 8.59042 9.1904 8.82921 8.91709 9.02355C8.60871 9.24283 8.24209 9.38383 7.50886 9.66585L3 11.4L7.50886 13.1342C8.24209 13.4162 8.60871 13.5572 8.91709 13.7765C9.1904 13.9708 9.42919 14.2096 9.62353 14.4829C9.84281 14.7913 9.98381 15.1579 10.2658 15.8912L12 20.4L13.7342 15.8912C14.0162 15.1579 14.1572 14.7913 14.3765 14.4829C14.5708 14.2096 14.8096 13.9708 15.0829 13.7765C15.3913 13.5572 15.7579 13.4162 16.4911 13.1342L21 11.4L16.4911 9.66585C15.7579 9.38383 15.3913 9.24283 15.0829 9.02355C14.8096 8.82921 14.5708 8.59042 14.3765 8.31711C14.1572 8.00873 14.0162 7.64212 13.7342 6.90889L12 2.40002Z"
                stroke={stroke || "#A4BCFD"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
export default RewardsSvgIcon
